var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 87,
    viewBox: "0 0 69 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6719 0H8.72393C6.80341 0 5.24658 1.55683 5.24658 3.47753V83.4594C5.24658 85.3799 6.80341 86.9369 8.72411 86.9369H65.5226C67.4431 86.9369 69.0002 85.3801 69.0002 83.4594V15.3283L53.6719 0Z",
    fill: "#E1E6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0002 47.9102H0.0302734V71.7286H69.0002V47.9102Z",
    fill: "#17C128"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0302734 71.7266L5.24657 76.5769V71.7266H0.0302734Z",
    fill: "#2D93BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6721 15.3283H69.0001L53.6719 0L53.6721 15.3283Z",
    fill: "#EBF0F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6211 15.3281L69.0002 22.5104V15.3281H56.6211Z",
    fill: "#D5D6DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.872 54.768H7.992V66H14.872V63.808H10.728V61.344H14.392V59.232H10.728V56.96H14.872V54.768ZM25.4483 66H28.6323L24.9203 60.432L28.4883 54.768H25.3843L23.4003 58.16L21.1443 54.768H17.9603L21.6403 60.288L18.0403 66H21.1443L23.1603 62.56L25.4483 66ZM31.4618 60.368C31.4618 63.728 33.7978 66.08 37.1098 66.08C39.7818 66.08 41.7978 64.592 42.4378 62.16H39.4298C38.9658 63.12 38.1178 63.6 37.0778 63.6C35.3978 63.6 34.2458 62.352 34.2458 60.368C34.2458 58.384 35.3978 57.136 37.0778 57.136C38.1178 57.136 38.9658 57.616 39.4298 58.576H42.4378C41.7978 56.144 39.7818 54.64 37.1098 54.64C33.7978 54.64 31.4618 57.008 31.4618 60.368ZM52.9132 54.768H46.0332V66H52.9132V63.808H48.7692V61.344H52.4332V59.232H48.7692V56.96H52.9132V54.768ZM56.6095 54.768V66H62.9295V63.888H59.3455V54.768H56.6095Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.60efe1d168306835e8c0b58234b1fb43.svg";
export { ForwardRef as ReactComponent };